module.exports = __webpack_public_path__ + "static/media/Inter-Medium.43188230.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Inter/Inter-Medium.ttf
// module id = 360
// module chunks = 17